// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3IL_x","item":"PaymentsMobile_item__1biME","label":"PaymentsMobile_label__3cLdU","amount":"PaymentsMobile_amount__3owFP"};